// extracted by mini-css-extract-plugin
module.exports = {"root":"Collapse_root__3nmoL","sm":"Collapse_sm__18tbe","lg":"Collapse_lg__158Z2"};